import { FunctionComponent } from "preact";
import { memo } from "preact/compat";

const Logo: FunctionComponent = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={{
        all: "unset",
      }}
    >
      <path
        d="M23 11.5353H20.0776C19.5603 8.17178 16.4569 4.93865 12.7069 4.26074C11.3362 4.02607 10.6638 4 9.13793 4V7.33742H3.37069C2.62069 7.33742 2 7.96319 2 8.7454C2 9.52761 2.62069 10.1534 3.37069 10.1534H9.13793V14.7945H3.39655C2.64655 14.7945 2.02586 15.4202 2.02586 16.2025C2.02586 16.9847 2.64655 17.6104 3.39655 17.6104H9.13793V21C10.6638 21 11.7241 20.9739 12.7328 20.7132C16.3793 19.7745 19.5345 16.7761 20.0517 13.4908H22.9741L23 11.5353Z"
        fill="#343A40"
      />
    </svg>
  );
});

Logo.displayName = "Logo";

export default Logo;
